import { Component, Input } from '@angular/core';
import { CompareFacadeService } from 'src/app/core/+store/compare/compare.facade';
import { SavedFacadeService } from 'src/app/core/+store/saved/saved.facade';
import { Institution } from 'src/generated/graphql';

@Component({
  selector: 'tad-institution-card',
  templateUrl: './institution-card.component.html',
  styleUrls: ['./institution-card.component.scss']
})
export class InstitutionCardComponent {
  @Input() public institution!: Institution;
  @Input() public saved!: boolean | undefined;
  @Input() public added!: boolean | undefined;
  @Input() public showRemove!: boolean | undefined;

  public showConfirm = false;

  constructor(
    private compareFacadeService: CompareFacadeService,
    private savedFacadeService: SavedFacadeService
  ) {}

  public save(event: MouseEvent): void {
    event.stopPropagation();
    if (this.institution?.id) {
      this.savedFacadeService.addToSaved(this.institution);
    }
  }

  public confirmRemove(event: MouseEvent): void {
    event.stopPropagation();
    this.showConfirm = true;
  }

  public cancelRemove(event: MouseEvent): void {
    event.stopPropagation();
    this.showConfirm = false;
  }

  public remove(event: MouseEvent): void {
    event.stopPropagation();
    if (this.institution?.id) {
      this.savedFacadeService.removeFromSaved(this.institution);
    }
  }

  public addToCompare(event: MouseEvent): void {
    event.stopPropagation();
    if (this.institution?.id) {
      this.compareFacadeService.addToCompare(this.institution);
    }
  }

  public removeFromCompare(event: MouseEvent): void {
    event.stopPropagation();
    if (this.institution?.id) {
      this.compareFacadeService.removeFromCompare(this.institution);
    }
  }
}
